import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit"
import { createBrowserHistory } from "history"
import { combineReducers } from "redux"
import { createReduxHistoryContext } from "redux-first-history"
import AuditReducer from "./auditTrail"
import CCTVReducer from "./cctvList"
import CompanyReducer from "./companyList"
import ECMReducer from './ecmList'
import generalConfigReducer from "./generalConfigSlice"
import GroupReducer from "./groupList"
import RegistrationReducer from "./registrationList"
import UserReducer from "./userList"

const { createReduxHistory, routerMiddleware, routerReducer } =
  createReduxHistoryContext({ history: createBrowserHistory() });

export const store = configureStore({
  reducer: combineReducers({
    router: routerReducer,
    userList: UserReducer,
    companyList: CompanyReducer,
    groupList: GroupReducer,
    cctvList: CCTVReducer,
    ecmList: ECMReducer,
    audit: AuditReducer,
    registrationList: RegistrationReducer,
    generalConfig: generalConfigReducer,
  }),
  middleware: [...getDefaultMiddleware(), routerMiddleware],
});

export const history = createReduxHistory(store);
